import { fade, palette } from './common/colors';
import { zIndexes } from './common/z_indexes';
import { colors, fonts, globalCss } from './stitches.config';

const globalRootStyles = {
  position: 'fixed',
  zIndex: zIndexes.base,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  overscrollBehaviorY: 'none',
  scrollbarWidth: 'thin',
  scrollbarGutter: 'auto',
};

const lightThemeStyles = {
  backgroundColor: colors.bgApplicationLight,
  color: colors.bodyNeutralLight,
  scrollbarColor: `${fade(palette.gray100, 0.9)} ${fade(palette.gray100, 0.3)}`,
};

const darkThemeStyles = {
  backgroundColor: colors.bgApplicationDark,
  color: colors.bodyNeutralDark,
  scrollbarColor: `${fade(palette.gray600, 0.7)} ${fade(palette.gray700, 0.5)}`,
};

export const injectGlobalAttoStyles = globalCss({
  body: {
    ...globalRootStyles,
    ...darkThemeStyles,

    fontSize: 16,
    fontFamily: fonts.sans,
    fontWeight: '$regular',

    '&.m-light': lightThemeStyles,

    '@prefersLight': lightThemeStyles,

    '&.m-dark': darkThemeStyles,

    '@prefersDark': darkThemeStyles,

    // Enable improved font rendering only on high-DPI displays
    '@media only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 13/10), only screen and (min-resolution: 120dpi)':
      {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
      },

    // forces full height in storybook so elements in portals aren't clipped
    '&.sb-show-main': {
      position: 'relative',
      overflow: 'auto',
    },
  },

  '#root': {
    ...globalRootStyles,

    position: 'relative',
  },
});
